import axios from "axios";

export default async function(email) {
  const resp = await axios.post('/register/verify-email', { email })
  return !resp.data
}
